import clsx from 'clsx';
import { isEmpty, kebabCase } from 'lodash';
import { useContext } from 'react';
import { createSearchParams, useNavigate } from 'react-router-dom';

import { OffersPageContext, Skeleton, StrapiImg } from 'components';
import { routes } from 'router';

const OffersCategories = () => {
  const navigate = useNavigate();
  const { offersCategoriesData, offersCategoriesLoading, selectedCategory } = useContext(OffersPageContext);

  const onCategoryChange = (category) => {
    const slugCategory = kebabCase(category.name);

    navigate({
      pathname: routes.offers.path,
      search: createSearchParams({ category: slugCategory }).toString()
    });
  };

  return (
    <div className="mb-6">
      {offersCategoriesLoading && (
        <ul className="flex justify-between gap-4 pb-3 overflow-x-auto">
          {Array.from({ length: 6 }, (_, index) => (
            <li key={`skeleton-offer-category${index}`}>
              <div className="flex flex-col gap-4 items-center">
                <Skeleton type="text" classNames="w-8 h-6 md:w-9 md:h-9" />
                <Skeleton type="text" classNames="w-12 h-4 md:w-28 md:h-6" />
              </div>
            </li>
          ))}
        </ul>
      )}

      {!offersCategoriesLoading && !isEmpty(offersCategoriesData?.data) && (
        <ul className="flex justify-between gap-4 pb-3 overflow-x-auto">
          {offersCategoriesData.data.map((category) => (
            <li
              key={`offer-category-li-${category.id}`}
              className={clsx('category-container', selectedCategory === kebabCase(category.name) && 'selected')}
            >
              <button
                type="button"
                onClick={() => onCategoryChange(category)}
                className="flex flex-col gap-4 items-center relative"
              >
                <StrapiImg image={category.icon} className="w-8 h-8 object-contain" />
                <p className="category-content">{category.name}</p>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default OffersCategories;
